import Cookies from 'js-cookie'
import { getDeviceType, getFbc } from '../../utils'

// https://segment.com/docs/connections/spec/page/
export const usePageTracking = (props) => {
  const { title, pageCategory, referrer } = props
  if (typeof window !== 'undefined' && window.analytics) {
    const fbc = Cookies.get('_fbc')
    const fbp = Cookies.get('_fbp')

    window.analytics.page(title, {
      name: title,
      path: window.location.pathname,
      category: pageCategory,
      url: window.location.href,
      branch: window?.phill?.BRANCH,
      device: getDeviceType(),
      action_source: 'website',
      fbc: fbc || getFbc() || null,
      fbp: fbp || null,
    })
  }
}
